import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-bone dark:bg-charcoal transition-colors duration-500">
      <Header />
      <main className="flex-1" data-testid="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
